import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  BooleanField,
  BooleanInput,
  DateField,
  DateInput,
  Resource,
  Show,
  Datagrid,
  EditButton,
  required,
} from "react-admin";

const LcaMethodologyVersionList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" label="Version ID" />
      <TextField source="name" label="Name" />
      <TextField source="description" label="Description" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="releaseDate" label="Release Date" />
      <DateField source="deprecatedDate" label="Deprecation Date" />
      <EditButton />
    </Datagrid>
  </List>
);

const LcaMethodologyVersionShow = (props) => (
  <Show {...props}>
    <SimpleForm>
      <TextField source="id" label="Version ID" />
      <TextField source="name" label="Name" />
      <TextField source="description" label="Description" />
      <BooleanField source="isActive" label="Active" />
      <DateField source="releaseDate" label="Release Date" />
      <DateField source="deprecatedDate" label="Deprecation Date" />
    </SimpleForm>
  </Show>
);

const LcaMethodologyVersionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" validate={required()} />
      <TextInput source="description" label="Description" multiline fullWidth />
      <BooleanInput source="isActive" label="Active" />
      <DateInput source="releaseDate" label="Release Date" />
      <DateInput source="deprecatedDate" label="Deprecation Date" />
    </SimpleForm>
  </Create>
);

const LcaMethodologyVersionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextField source="id" label="Version ID" />
      <TextInput source="name" label="Name" validate={required()} />
      <TextInput source="description" label="Description" multiline fullWidth />
      <BooleanInput source="isActive" label="Active" />
      <DateInput source="releaseDate" label="Release Date" />
      <DateInput source="deprecatedDate" label="Deprecation Date" />
    </SimpleForm>
  </Edit>
);

const lcaMethodologyVersionResource = () => (
  <Resource
    name="lcaMethodologyVersion"
    options={{ label: "LCA Versions", menuGroup: "Bcome" }}
    list={LcaMethodologyVersionList}
    show={LcaMethodologyVersionShow}
    create={LcaMethodologyVersionCreate}
    edit={LcaMethodologyVersionEdit}
  />
);

export default lcaMethodologyVersionResource;
